<template>
  <div>
    <b-form>
      <span>Pilih Mata Pelajaran </span>
      <b-form-select style="width: 50%" v-model="selected" :options="options" class="ml-6"></b-form-select>
    </b-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: null,
      options: [
        { value: null, text: '--Pilih Mata Pelajaran--' },
        { value: 'Pendidikan Pancasila', text: 'Pendidikan Pancasila' },
        { value: 'Matematika Dasar', text: 'Matematika Dasar' }
      ]
    };
  }
 }
</script>